module.exports = {
    API_DOMAIN: 'https://apirmdl.timcreated.me/',
    // API_DOMAIN: 'http://localhost:5000/',
};
/* 
Google account:
ID: radiomdl.fv@gmail.com
PASSWORD: RMDLAdmin_2020

Mail accounts:
ID: admin@radio-fv.ml
PASSWORD: RMDLAdmin_2020

ID: contact@radio-fv.ml
PASSWORD: RMDLContact_2020
*/
